module.exports = __webpack_public_path__ + "static/media/icon-perspectives.cb4646e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-perspectives.svg
// module id = 621
// module chunks = 0